<template>
    <div class="information-box" :class="messageType ? `information-box--${messageType}` : 'information-box--info'">
        <v-icon class="information-box__icon" :icon="icon" size="22" />
        <span v-html="message"></span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    message: string;
    messageType?: 'info' | 'warning' | 'error';
}

const props = defineProps<Props>();

const icon = computed(() => {
    switch (props.messageType) {
        case 'info':
            return 'mdi-information';
        case 'warning':
            return 'mdi-alert';
        case 'error':
            return 'mdi-alert-circle';
        default:
            return 'mdi-information';
    }
});
</script>

<style lang="scss">
.information-box {
    border-width: 1px 1px 1px 4px;
    border-style: solid;
    border-color: var(--border-color);
    border-radius: 6px;
    padding: 12px 12px 12px 44px;
    font-size: 16px;
    position: relative;

    &__icon {
        color: var(--icon-color);
        position: absolute;
        left: 11px;
        top: calc(50% - 11px);
    }

    &--info {
        --border-color: #5cb1ff;
        --icon-color: #5cb1ff;
    }

    &--error {
        --border-color: #d7251f;
        --icon-color: #d7251f;
    }

    &--warning {
        --border-color: #d27e00;
        --icon-color: #d27e00;
    }
}
</style>
